<template>
  <div>
    <div class="news">
      <!--            <div class="my-news">-->
      <!--                <div class="u-flex u-row-between w100">-->
      <!--                    <div class="title">全部消息</div>-->
      <!--                    &lt;!&ndash; <div class="u-flex">-->
      <!--                       <el-button type="primary" size="small">删除</el-button>-->
      <!--                       <el-button class="ml10" type="primary" size="small">标记已读</el-button>-->
      <!--                       <el-button class="ml10" type="primary" size="small">全部已读</el-button>-->
      <!--                    </div> &ndash;&gt;-->
      <!--                </div>-->
      <!--            </div>-->
      <el-table ref="whitelistTable" class="whitelist-table mt20" :data="dataSource"
                :border="false" row-key="id">

        <el-table-column prop="title" label="消息" align="center"/>
        <el-table-column prop="time" label="发布时间" align="center">
          <template #default="scope">
            <span>{{ formatTime(scope.row.createtime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="op" label="操作" align="center">
          <template #default="scope">
            <el-button type="text" size="small" @click="handleRead(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <div class="pagination">
      <el-pagination
          background
          layout="total,prev, pager, next"
          :total="total"
          :page-size="pageSize"
          @current-change="handleCurrentChange"
      />
    </div>
    <Dialog
        title="详情"
        ref="message"
    >
      <div v-html="dialogContent"></div>
      <span slot="btn" style="display: flex;justify-content: center;margin-top: 20px">
        <el-button size="small" @click="$refs.message.onClose()">关闭</el-button>
      </span></Dialog>

  </div>
</template>

<script>
import Dialog from "@/components/Dialog.vue";

export default {
  name: 'Index',
  components: {Dialog},
  data() {
    return {
      type: '',
      dataSource: [],
      page: 1,
      pageSize: 10,
      total: 0,
      messageShow: false,
      dialogContent: ''
    }

  },
  mounted() {
    this.curIdx = this.$route.params.index || 0
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$api.message.getList({page: this.page}).then(res => {
        this.dataSource = res.data.data
        this.total = res.data.total
      })
    },
    onTab(index) {
      this.navIndex = index
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    formatTime(ts) {
      if (!ts) return '-';
      // 支持10位和13位时间戳
      const t = ts.toString().length === 10 ? ts * 1000 : ts;
      const d = new Date(t);
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
    },
    handleRead(row) {

      this.dialogContent = row.content
      this.$refs.message.onOpen()
    }
  },

}
</script>

<style scoped>
.news {
  margin-top: 20px;
  border-radius: 8px;
//border: 1px solid #ccc;
}

.whitelist-table {
  border-radius: 0;
  overflow: hidden;
  box-shadow: none;
}

.whitelist-table ::v-deep tr th {
  background: #f5f7fa;
  color: #222;
  font-weight: 600;
  font-size: 15px;
}

.whitelist-table ::v-deep tr {
  transition: background 0.2s;
}

.whitelist-table ::v-deep tr:hover td {
  background: #f0f7ff;
}

.whitelist-table ::v-deep td,
.whitelist-table ::v-deep th {
  padding: 12px 0;
}

.title {
  font-size: 16px;
  font-weight: 600;
}

.my-news {
  padding: 20px;
}

.table ::v-deep tr th {
  background: #f5f5f5;
}

.table::before {
  height: 0;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
